import _get from "lodash/get";
import styled from 'styled-components';
import { typographyTheme } from '~typography';
import formTheme from '../styles/formTheme';
var LabelInline = styled.div.withConfig({
  displayName: "LabelInline",
  componentId: "iwgm9v-0"
})(["color:", ";display:block;font-family:", ";font-size:1rem;padding:0.3125rem 0;"], function (props) {
  return _get(props, "theme.form.label[" + props.skin + "].color", formTheme.form.label[props.skin].color);
}, function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
});
export default LabelInline;